import React, {useEffect, useState} from 'react';
import {Divider, HStack, VStack} from "native-base";
import {Colors} from "../../../../../../../styles/Colors";
import AppText from "../../../../../../common/AppText";
import {t} from "../../../../../../../services/i18n";
import SimpleInput from "../../../../../../common/SimpleInput";
import {GlobalStyleAttributes, WebGlobalStyles} from "../../../../../../../styles/GlobalStyles";
import {useDispatch, useSelector} from "react-redux";;
import InfoTooltip from "../../../../../../common/InfoTooltip";
import CustomSwitch from "../../../../../../common/CustomSwitch";
import {toggleScheduleLoader, toggleSuccessFlag} from "../../../../../../../redux/ScheduleSlice";
import {CONFIRMATION_SETTINGS, TRIAL_LIMIT_SETTING} from "../../../../../../../services/ConstHelper";
import {fetchApi} from "../../../../../../../services/HTTP";
import {updateBox} from "../../../../../../../redux/boxSlice";
import {store} from "../../../../../../../redux/store";
import {isMobile} from "../../../../../../../services/Helpers";

const AppointmentConfirmation = (props) => {
    const { values, setFieldValue, errors } = props;
    const confirmationSettings = useSelector(state => state.box.box.settings?.confirmation_settings)
    const shouldSave = useSelector((state) => state.schedule.settingsSaveFlag);
    const [showArrivalStatus, setShowArrivalStatus] = useState(confirmationSettings?.showStatusOnCalendar);
    const [allowCancelBooking, setAllowCancelBooking] = useState(confirmationSettings?.allowCancel);
    const [isConfirmationTextOpen, setIsConfirmationTextOpen] = useState(!!confirmationSettings?.confirmationText);
    const [confirmationText, setConfirmationText] = useState(confirmationSettings?.confirmationText);
    const mobile = isMobile
    const dispatch = useDispatch();


    useEffect(() => {
        if(shouldSave) {
            save()
        }
    }, [shouldSave]);

    const setConfirmation = (text) => {
        setConfirmationText(text)
        setFieldValue('confirmationSettings.confirmationText', text)
    }

    const toggleConfirmationText = () => {
        setConfirmation(isConfirmationTextOpen ? null : '')
        setIsConfirmationTextOpen(prev => !prev)
    }

    const toggleConfirmation = (value) => {
        setFieldValue('confirmationSettings.showStatusOnCalendar', value)
        setShowArrivalStatus(value)
    }

    const toggleConfirmationCancel = (value) => {
        setFieldValue('confirmationSettings.allowCancel', value)
        setAllowCancelBooking(value)
    }


    const save = async () => {
        try {
            if (mobile) {
                dispatch(toggleScheduleLoader(true));
                const setting = {prop_name: CONFIRMATION_SETTINGS, properties: {confirmationText: values.confirmationSettings.confirmationText, showStatusOnCalendar: values.confirmationSettings.showStatusOnCalendar}}
                const res = await fetchApi(`boxes/settings`, 'POST', setting, false, true);
                dispatch(toggleScheduleLoader(false));
                dispatch(toggleSuccessFlag(true))
                dispatch(updateBox({
                    settings: {
                        ...store.getState().box.box.settings,
                        [CONFIRMATION_SETTINGS]: setting.properties
                    }
                }))
            }
        }catch(error) {
            console.log('error',error)
            dispatch(toggleScheduleLoader(false));
        }
    }

    return (
        <VStack space={'1.5rem'}>
            <VStack space={'0.25rem'}>
                <HStack justifyContent={'space-between'} alignItems={'center'}>
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('appointmentConfirmationLbl')}</AppText>
                    <CustomSwitch isChecked={showArrivalStatus} onToggle={toggleConfirmation }/>
                </HStack>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('appointmentConfirmationTxt')}</AppText>
            </VStack>
            <Divider w={'100%'} color={Colors.borderColor}/>
            <VStack space={'0.25rem'}>
                <HStack justifyContent={'space-between'} alignItems={'center'}>
                    <HStack>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('appointmentConfirmationCancelLbl')}</AppText>
                        <InfoTooltip title={t('appointmentConfirmationCancelTooltip')} />
                    </HStack>
                    <CustomSwitch isChecked={allowCancelBooking} onToggle={toggleConfirmationCancel }/>
                </HStack>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('appointmentConfirmationCancelTxt')}</AppText>
            </VStack>
            <Divider w={'100%'} color={Colors.borderColor}/>
            <VStack space={'1rem'}>
                <HStack justifyContent={'space-between'} alignItems={'center'}>
                    <HStack>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('showConfirmationText')}</AppText>
                        <InfoTooltip title={t('text-confirmation-info')} />
                    </HStack>
                    <CustomSwitch isChecked={isConfirmationTextOpen} onToggle={toggleConfirmationText}/>
                </HStack>
                {
                    isConfirmationTextOpen &&
                    <SimpleInput inputType={'multiline'}
                                 value={confirmationText}
                                 onChangeCallback={setConfirmation}
                                 rows={6}
                    />
                }
            </VStack>

        </VStack>
    );
};

export default AppointmentConfirmation;
